import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu_right",
  "use": "icon-menu_right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-menu_right\"><path d=\"M426.67 725.33c-10.92 0-21.84-4.17-30.17-12.5-16.66-16.66-16.66-43.68 0-60.34L537 511.99l-140.5-140.5c-16.66-16.66-16.66-43.68 0-60.34 16.66-16.66 43.68-16.66 60.34 0L627.5 481.83c16.66 16.66 16.66 43.68 0 60.34L456.83 712.84c-8.32 8.33-19.24 12.49-30.16 12.49z\" p-id=\"1426\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol